<template>
    <div>
      <h5>
        Q{{item.order}}
      </h5>
      <div class="boardBg surveyBox adminSurbeyBox">
        <div class="surveyBoxTop flex flexAlignS">
          <h4>
            선형
          </h4>
          <button @click="$emit('onClickDeleteItem', item.order-1)"></button>
        </div>
        
        <b-form-checkbox class="termCheckBox" v-model="essential">필수항목</b-form-checkbox>

        <div class="surveyBoxInput flex flexAlignS">
          <label for="">질문</label>
          <input v-model="item.question" maxlength="170"/>
        </div>

        <div>
          <div class="flex surveySelectBoxContain">
            <div class="surveySelectBox mini">
              <b-form-select v-model="start" :options="startOptions"></b-form-select>
            </div>
            <span class="flex flexAlignC">~</span>
            <div class="surveySelectBox mini">
              <b-form-select v-model="end" :options="endOptions"></b-form-select>
            </div>
          </div>

          <div v-for="(listItem, index) in list" :key="index" class="surveyBoxInput inputWdCt flex flexAlignS">
            <label v-if="listItem != 'BLANK'">{{index}}번 라벨</label>
            <input placeholder="라벨(선택사항) 50자 제한" v-if="listItem != 'BLANK'" v-model="list[index]" maxlength="341"/>
          </div>
<!-- 
          <div class="surveyBoxInput inputWdCt flex flexAlignS">
            
            <input v-model="data.startLabel" placeholder="라벨(선택사항) 50자 제한" />
          </div>
          <div class="surveyBoxInput inputWdCt flex flexAlignS">
            <label for="">종료 라벨</label>
            <input v-model="data.endLabel" placeholder="라벨(선택사항) 50자 제한" />
          </div> -->
        </div>
      </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'Linear',
  props:{
    item: null,
  },
  data(){
    return{
      list: [], // String List
      start: 0,
      startOptions: [
        { value: 0, text: '0' },
        { value: 1, text: '1' }
      ],
      end: 2,
      endOptions: [
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
        { value: 6, text: '6' },
        { value: 7, text: '7' },
        { value: 8, text: '8' },
        { value: 9, text: '9' },
        { value: 10, text: '10' },
      ]
    }
  },
  computed:{
    essential:{
      get(){
        if(this.item.essential === 'Y') return true
        else return false
      },
      set(value){
        if(value) this.item.essential = 'Y'
        else this.item.essential = 'N'
      }
    }
  },
  beforeMount(){
    this.list = new Array(11)
    var orderMin = 2
    var orderMax = 1

    for(var i = 0; i < 11; i++){
      this.list[i] = ''

      for(var j = 0; j < this.item.options.length; j++){
        const order = this.item.options[j].order
        if(order == i){
          this.list[i] = this.item.options[j].data

          if(order < orderMin) orderMin = order
          if(order > orderMax) orderMax = order
        }
      }
    }

    this.start = orderMin < 2 ? orderMin : 0
    this.end = orderMax > 1 ? orderMax : 2

    for(var z = 0; z < 11; z++){
      if(z < this.start || z > this.end) this.list[z] = 'BLANK'
    }

    this.setOptions({
      item: this.item, 
      list: this.list
    })
  },
  watch:{
    start:{
      handler: 'watchHandlerRange'
    },
    end:{
      handler: 'watchHandlerRange'
    },
    list:{
      deep: true,
      handler(list){
        this.setOptions({
          item: this.item,
          list: list
         })
      }
    }
  },
  methods:{
    ...mapMutations('survey', ['setOptions']),
    watchHandlerRange(){
      for(var i = 0; i < 11; i++){
        if(i < this.start || i > this.end) this.list[i] = 'BLANK'
        else {
          var data = ''
          for(var j = 0; j < this.item.options.length; j++){
            if(this.item.options[j].order == i){
              data = this.item.options[j].data
            }
          }
          this.list[i] = data
        }
      }

      this.setOptions({
        item: this.item, 
        list: this.list
      })
    }
  }
}
</script>